import { type User } from '../../../../contexts';
import { APPLICATION_STATUS_TYPE } from '../../../../utils/statusConstants/statusConstants';
import { OFFER_STATUS } from './GSToDoList';

export const gsToDoFilter = {
  status: {
    in: [APPLICATION_STATUS_TYPE.UNDER_GS],
  },
};

export const GSOfferFilter = {
  application: {
    status: {
      in: [
        APPLICATION_STATUS_TYPE.OFFERED,
        APPLICATION_STATUS_TYPE.GS_ASSESSED,
      ],
    },
  },
};

export const GSOverviewFilter = {
  application: {
    status: {
      in: [
        APPLICATION_STATUS_TYPE.SUBMITTED,
        APPLICATION_STATUS_TYPE.SUPERVISOR_NOMINATED,
        APPLICATION_STATUS_TYPE.WITHDRAWN,
      ],
    },
  },
};

export const applicationSearchAssessFilter = (applicationNo: string): any => {
  return {
    application: {
      applicationNo: { in: [applicationNo] },
    },
  };
};

/** to get application number in homepage */
export const GSApplicationPaginatedFilter = {
  application: {
    status: {
      in: [
        APPLICATION_STATUS_TYPE.UNDER_GS,
        APPLICATION_STATUS_TYPE.FRCSB_ASSESSED,
        APPLICATION_STATUS_TYPE.DSRC_ASSESSED,
      ],
    },
  },
};

export const offerStatusFilter = (offerStatus: string[]): any => {
  return {
    offerStatus: {
      in: offerStatus,
    },
  };
};

export const offerListFilter = (user: User | null): any => {
  const filter = {
    offerModel: {
      status: {
        in: [
          OFFER_STATUS.APPLICANT_ACCEPTED,
          OFFER_STATUS.APPLICANT_REJECTED,
          OFFER_STATUS.OVERDUE,
          OFFER_STATUS.MEET_CONDITION_LAPSED,
          OFFER_STATUS.RELEASED,
        ],
      },
    },
  };

  return filter;
};

export const gsConditionToMeetNumFilter = (): any => {
  const filter = {
    and: [
      {
        status: {
          in: [
            APPLICATION_STATUS_TYPE.OFFERED,
            APPLICATION_STATUS_TYPE.OVERDUE,
            APPLICATION_STATUS_TYPE.REGISTERED,
            APPLICATION_STATUS_TYPE.CONDITION_MEET_LAPSED,

            APPLICATION_STATUS_TYPE.REGISTRATION_FEE_PENDING,
            APPLICATION_STATUS_TYPE.REGISTRATION_FEE_SETTLED,
            APPLICATION_STATUS_TYPE.UNDER_REGISTRATION,
          ],
        },
      },
      {
        meetConditionCheckModel: {
          isFirmOffer: false,
        },
      },
    ],
  };
  return filter;
};
